import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';
import TextAreaLabel from '../../../exportacion_react_pdf/TextAreaLabel';
import SelectGroup from '../../../exportacion_react_pdf/SelectGroup';
import TablaCalificacion from '../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../exportacion_react_pdf/TextAreaLabelGroup';

const secciones_enfoque_genero = [
  {
    key: '1',
    title: 'ENFOQUES DE GÉNERO Y DIFERENCIALES ',
    questions: [
        {
            section: '1.1',
            description: 'El/la productor/a identifica 1 o más temáticas específicas de género en las que ha sido formado/a, relevantes para su iniciativa productiva, Ej: Equidad en la participación y toma de decisiones, roles de liderazgo femenino, distribución equitativa de tareas y carga de trabajo laboral y de cuidado, prevención de la violencia basada en género, masculinidades corresponsables y no violentas.',
        },
        {
            section: '1.2',
            description: 'El/la productor/a refiere 1 o más estrategias implementadas en su unidad productiva, que posibilitan la igualdad de acceso a recursos y oportunidades para hombres, mujeres y población diferencial, Ej: Distribución equitativa de tareas, participación de las mujeres en organos de desición, adapatación de equipos e instalaciones a población adulta mayor y/o en condición de discapacidad, espacios de formación específicos para mujeres y sus intereses y necesidades formativas, espacios diseñados para la conciliación de las actividades productivas y de cuidado como salas de lactancia, etc...',
        }

    ],
}
  ];

// Define el documento
const ExportPaso5 = ({ formData, styles  }) => {
    return (
    <>
    {/* Sección de Identificació del proyecto */}
    <View style={styles.section}>

        <Text style={styles.title_1}>ENFOQUE DE GÉNERO</Text>


        <CheckboxGroup
            label='¿Ha recibido capacitación específica sobre igualdad de género?'
            selectedValue={formData?.capacitacion_igualdad_genero || ''}>
        </CheckboxGroup>

        <CheckboxGroup
            label='¿Ha implementado prácticas que favorezcan la equidad de género en su unidad productiva?'
            selectedValue={formData?.implementado_practicas_equidad_genero || ''}>
        </CheckboxGroup>

       
        <TextAreaLabelGroup
            label='¿Quién es responsable de las actividades de cuidado en su hogar?'
            selectedValue={formData?.responsable_acitividades_cuidado_hogar || ''}>
        </TextAreaLabelGroup>

        <QuestionResponse
            label='¿Considera que esta carga de trabajo afecta su participación en su unidad de negocio?'
            value={formData?.carga_trabajo_afecta_productividad || ''}>
        </QuestionResponse>

        <Text style={styles.title_1}>CAPACIDADES DE ENFOQUE-TRANSVERSAL</Text>

        <TablaCalificacion evaluacion={formData?.capacidades_enfoque_transversal} secciones={secciones_enfoque_genero}></TablaCalificacion>

    </View>
</>
    )

};

export default ExportPaso5;